export default __webpack_public_path__ + "static/media/offer-3.4bc299b0.jpg";